import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_LOGIN_SETTINGS_TABLE,
  API_LOGIN_SETTINGS_LIST,
  API_LOGIN_SETTINGS_UPSERT,
} from 'store/actions/loginSettingsActions';

export const loginSettings = (state = {}, action = null) => {
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_LOGIN_SETTINGS_TABLE,
    API_LOGIN_SETTINGS_LIST,
    API_LOGIN_SETTINGS_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }
  return state;
};
